export const WELCOME = '/';
export const DASHBOARD = '/dashboard';
export const LOGIN = '/login';
export const REGISTER = '/register';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/reset-password';
export const USER_PROFILE = '/profile';
export const ABOUT = '/about';
export const STRUCTURE = '/structure';
export const MEMBERS = '/members';
export const PROJECTS = '/projects';
export const CONTACT = '/contact';
export const ARTICLES = '/articles';
export const SINGLE_ARTICLE = '/articles/:id';
export const MEDIA = '/media';
export const SERVICES = '/services';
export const COMPANIES = '/companies';
export const DOCUMENTS = '/documents';
export const SINGLE_COMPANY = '/companies/:id';
export const INOVATION_POOL = '/inovation-pool';
export const VMC_CLINIC = '/vmc-klinika';
export const VMC_FORUM = '/vmc-forum';
export const SOK_PROJECT_PAGE = '/sok-project'
